<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="../../assets/PerfumadasPreto.png" width="250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <!-- INSTAGRAM -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #8134AF, #515BD4)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">Instagram</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <v-btn class="ml-2 mb-2" height="40px" outlined right href="https://www.instagram.com/perfumadasoficial/" target="_blank">Seguir</v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile>
                            <v-icon size="100">mdi-instagram</v-icon>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- YOUTUBE -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #FF0000, #FF0000)">
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="text-h6">YouTube</v-card-title>
                            <v-card-subtitle></v-card-subtitle>
                            <v-card-actions>
                              <v-btn class="ml-2 mb-2" height="40px" outlined right href="https://www.youtube.com/channel/UC-cUjRWIVTnSbkEhfpfeMbA" target="_blank">Inscrever</v-btn>
                            </v-card-actions>
                          </div>
                          <v-avatar class="ma-3" size="100" tile>
                            <v-icon size="100">mdi-youtube</v-icon>
                          </v-avatar>
                        </div>
                      </v-card>
                    </v-col>
                    <!-- DOAÇÃO -->
                    <v-col cols="12" sm="12" md="8" lg="8">
                      <v-card dark style="background: linear-gradient(to right, #e45f50, #ef9c74)">
                        <v-card-title class="text-h6" style="justify-content: center">Doação</v-card-title>
                        <v-card-subtitle style="text-align: center">Complexo da Liberdade</v-card-subtitle>
                        <v-card-text tile style="text-align: center">
                          <img :src="imagemPixDoacao" width="100%" style="max-width: 250px">
                          <v-row dense>
                            <v-col cols="12">
                              <v-text-field dense outlined hide-details id="chavePix" v-model="chavePix" label="Chave Pix" readonly></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-btn dark outlined block @click="doCopy('chavePix')">Copiar Chave Pix</v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAIPassIntelite.png" width="250px">
          </a>
        </div>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  // import { baseApiUrl } from '@/global'
  import { mapState } from 'vuex'
  export default {
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        imagemPixDoacao: require('../../assets/qrCodeDoacao.png'),
        chavePix: 'complexodaliberdade@gmail.com',
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
      }
    },

    mounted: function () {
      this.$validator.localize('pt', this.dictionary)
    },

    methods: {
      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #9f6758, #6e463b);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }
</style>